import { Button } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { ArrowBack } from "@material-ui/icons"
import React from "react"
import { useHistory } from "react-router-dom"

const useStyles = makeStyles(theme => ({
    voltar: {
        textTransform: "none",
        color: "#2c3e50",
        fontWeight: 600,
        borderRadius: 20,
        marginBottom: theme.spacing(2),
    },
}))

export function BotaoVoltar() {
    const classes = useStyles()
    const history = useHistory()

    return (
        <Button
            className={classes.voltar}
            startIcon={<ArrowBack />}
            onClick={() => history.push("/servicos/modulo/editar-aplicativo")}
        >
            Voltar
        </Button>
    )
}
